// externals
import { useSelector } from 'react-redux';

// components
import type { DatePickerEventValue } from '@interstate/components/DatePicker';
import { DatePicker } from '@interstate/components/DatePicker';
import type { InterstateOnChangeEvent } from '@interstate/components/InterstateEvents';
import type { TextInputSize } from '@interstate/components/TextInput';

// selectors
import * as configSelectors from '@makemydeal/dr-dash-store/selectors/config';

// consts/enums
import { DATE_FORMAT, SECOND_PAYMENT_DATE } from '../constants';
import { dateUtils } from '@makemydeal/dr-common-utils';
import { dealLockHooks, usePaymentFrequency } from '../hooks';

interface SecondPaymentDueDateFieldProps {
    id: string;
    value: string;
    onChange: (e: InterstateOnChangeEvent<DatePickerEventValue>, type: string) => void;
    showStyledLabel?: boolean;
    size?: TextInputSize;
}

export const SecondPaymentDueDateField: React.FC<SecondPaymentDueDateFieldProps> = ({
    id,
    value,
    onChange,
    showStyledLabel = false,
    size = 'small'
}) => {
    const maxAllowedFutureMonthsInDateField = useSelector(configSelectors.getMaxAllowedFutureMonthsInDateField);
    const isLocked = dealLockHooks.useIsDealLocked();
    const { isOnePayLease } = usePaymentFrequency();

    const currentDate = new Date();
    const maxAllowedDate = new Date(currentDate.setMonth(currentDate.getMonth() + maxAllowedFutureMonthsInDateField));
    const oneYearAgoFromNow = new Date(currentDate.setFullYear(currentDate.getFullYear() - 1));
    const isDisabled = isOnePayLease;

    return (
        <>
            <div aria-label={SECOND_PAYMENT_DATE} data-testid={`${id}-label`}>
                <DatePicker
                    aria-label={SECOND_PAYMENT_DATE}
                    data-testid={id}
                    id={id}
                    label={SECOND_PAYMENT_DATE}
                    dateFormat={DATE_FORMAT}
                    value={value ? new Date(dateUtils.formatUtcDateTimeToDateOnly(value)) : null}
                    onChange={(e) => onChange(e, SECOND_PAYMENT_DATE)}
                    disabled={isDisabled || isLocked}
                    required={false}
                    locale="en-US"
                    maxDate={maxAllowedDate}
                    minDate={oneYearAgoFromNow}
                    displayLabel={!showStyledLabel}
                    size={size}
                />
            </div>
        </>
    );
};
